import React from 'react';

import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import { editTextStyle } from '../Pages/Login'
import { verifyPassword } from '../Networking/APIClient';
import { passwordHelperTextStyle } from '../Pages/SignUpStep1'

import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import FormControl from '@material-ui/core/FormControl';
import IconButton from '@material-ui/core/IconButton';
import FormHelperText from '@material-ui/core/FormHelperText';


const buttonContainerStyle = {
    marginRight: 10,
    float: 'right',
    paddingTop: 20,
    paddingBottom: 20
}

const buttonStyle = {
    width: 100,
    marginRight: 10,
    marginLeft: 20,
};

let t;
let self;
class VippsPaymentInformationDialog extends React.Component {
    constructor(props) {
        super(props);
        t = props.t;
        self = this;
        this.state = {
            open: props.open,
            cancelVippsDialogOpen: false,
            showPassword: false,
            password: {
                value: '',
                error: false,
                helperText: ''
            },
        }
    }

    handleChange = name => event => {
        this.setState({
            [name]: event.target.checked,
        });
    };

    handleClickOpen = () => {
        this.props.toggleDialog();
    };

    handleClose = () => {
        this.props.toggleDialog();
    };

    onOkClicked = e => {
        e.preventDefault();
        this.props.toggleDialog();
    };

    // Opens dialog with information about Vipps subscription and how cancelling works
    onOpenVippsPaymentInformationClicked = e => {
        e.preventDefault();
        this.setState({
            cancelVippsDialogOpen: true
        });
    };

    onCancelClicked = e => {
        e.preventDefault();
        this.setState({
            cancelVippsDialogOpen: false
        });
    }

    // Cancels the Vipps subscription and disables automatic renewal
    onStopVippsPaymentsClicked = e => {
        if (e != null) {
            e.preventDefault();
        }
        if ((this.state.password.value === '' || this.props.customer.email === '') && this.props.customerIsRegistered) {
            return;
        }
        let myCredentials;
        if (!this.props.customerIsRegistered) {
            myCredentials = {
                email: this.props.customer.email,
                password: "NotASecret"
            }
            self.props.cancelVippsSubscriptionAndDisableAutomaticRenewal(myCredentials);
            return;
        }
        else {
            myCredentials = {
                email: this.props.customer.email,
                password: this.state.password.value
            }
        }
        
        const onCorrectPassword = function onCorrectPassword() {
            self.setState({
                cancelVippsDialogOpen: false
            });
            self.props.cancelVippsSubscriptionAndDisableAutomaticRenewal(myCredentials);
        }
        const onError = function onError() {
            console.log("Login error");
            self.setState((prevState) => ({
                password: {
                    value: prevState.password.value,
                    error: true,
                    helperText: t('wrong_password')
                },
            }));
        }
        verifyPassword(myCredentials, false, onCorrectPassword, onError);

    }

    handlePasswordInputChange = name => event => {
        this.setState({
            ...this.state,
            [name]: {
                ...this.state[name],
                value: event.target.value
            }
        });
    };

    handleMouseDownPassword = event => {
        event.preventDefault();
    };

    handleClickShowPassword = () => {
        this.setState(state => ({ showPassword: !state.showPassword }));
    };

    // This method is needed so that the soft keyboard of phones closes
    // when the "submit" button of the soft keyboard is clicked
    // on the last text field
    onKeyPressed = (e) => {
        if (e.key === 'Enter') {
            document.activeElement.blur();
        }
    }

    render() {
        const { fullScreen } = this.props;

        const cancelVippsDialog =
        this.props.customerIsRegistered ? //Customer is registered, show password input
            <Dialog
                fullScreen={fullScreen}
                open={this.state.open}
                onClose={this.handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">

                <DialogTitle id="alert-dialog-title">{t('cancel_vipps_payments_title')}</DialogTitle>

                <DialogContent>
                    <DialogContentText component={'span'} id="alert-dialog-description">
                        {t('cancel_vipps_payments_message_2')}
                    </DialogContentText>
                    <FormControl style={editTextStyle}>
                    <InputLabel htmlFor="adornment-password">{t('password')}</InputLabel>
                    <Input
                        id="adornment-password"
                        type={this.state.showPassword ? 'text' : 'password'}
                        value={this.state.password.value}
                        error={this.state.password.error}
                        text={t('password')}
                        onChange={this.handlePasswordInputChange('password')}
                        onKeyPress={e => this.onKeyPressed(e)}
                        endAdornment={
                            <InputAdornment position="end">
                                <IconButton
                                    aria-label="Toggle password visibility"
                                    onClick={this.handleClickShowPassword}
                                    onMouseDown={this.handleMouseDownPassword}
                                >
                                    {this.state.showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                            </InputAdornment>
                        }
                    />
                    <FormHelperText style={passwordHelperTextStyle} id="weight-helper-text">{this.state.password.helperText}</FormHelperText>
                    </FormControl>
                </DialogContent>
                <DialogActions>
                    <div style={buttonContainerStyle}>
                        <Button
                            variant="contained"
                            color="default"
                            onClick={e => this.onStopVippsPaymentsClicked(e)}>
                            {t('cancel_vipps_payments_title')}
                        </Button >
                        <Button
                            style={buttonStyle}
                            variant="contained"
                            color="primary"
                            onClick={e => this.onCancelClicked(e)}>
                            {t('cancel')}
                        </Button >
                    </div>
                </DialogActions>
            </Dialog>
            : //Customer is not registered, don't show the password input field
            <Dialog
                fullScreen={fullScreen}
                open={this.state.open}
                onClose={this.handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">

                <DialogTitle id="alert-dialog-title">{t('cancel_vipps_payments_title')}</DialogTitle>

                <DialogContent>
                    <DialogContentText component={'span'} id="alert-dialog-description">
                        {t('cancel_vipps_message_3')}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <div style={buttonContainerStyle}>
                        <Button
                            variant="contained"
                            color="default"
                            onClick={e => this.onStopVippsPaymentsClicked(e)}>
                            {t('cancel_vipps_payments_title')}
                        </Button >
                        <Button
                            style={buttonStyle}
                            variant="contained"
                            color="primary"
                            onClick={e => this.onCancelClicked(e)}>
                            {t('cancel')}
                        </Button >
                    </div>
                </DialogActions>
            </Dialog>
        const automaticRenewalIsOff = 
            <div>
                {t('automatic_renewal_is_off_message')}
            </div>
        const cancelSubscriptionContent =
            <div>
                {t('cancel_vipps_payments_message_1')}
                <br />
                <br />
                <Button
                    autoFocus
                    variant="contained"
                    color="default"
                    onClick={e => this.onOpenVippsPaymentInformationClicked(e)}>
                    {t('cancel_vipps_payments_title')}
                </Button >
            </div>

        return (
            <div>
                {this.state.cancelVippsDialogOpen ? cancelVippsDialog : null}
                <Dialog
                    fullScreen={fullScreen}
                    open={this.state.open}
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">

                    <DialogTitle id="alert-dialog-title">{t('manage_vipps_payments_title')}</DialogTitle>

                    <DialogContent>
                        <DialogContentText component={'span'} id="alert-dialog-description">
                            {t('manage_vipps_payments_message_1')}
                            <br />
                            <br />
                            {t('manage_vipps_payments_message_2')}
                            <br />
                            <br />
                            <br />
                            {this.props.automaticRenewalWillBeDone ? cancelSubscriptionContent : automaticRenewalIsOff}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            style={buttonStyle}
                            variant="contained"
                            color="primary"
                            onClick={e => this.onOkClicked(e)}>
                            {t('ok')}
                        </Button >
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

VippsPaymentInformationDialog.propTypes = {
    fullScreen: PropTypes.bool.isRequired,
};


export default withMobileDialog()(VippsPaymentInformationDialog);


// WEBPACK FOOTER //
// ./src/Components/VippsPaymentInformationDialog.js